import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'

// Stylesheet order mirrors the <head> of every original page, minus the three
// vendor sheets whose components do not exist on any of the 19 pages
// (splide, slim-select, flatpickr — all verified 0 occurrences, and none of them
// carry global element selectors, so dropping them cannot shift rendering).
import '@kkf/design/assets/fonts/flaticon_charitics.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'swiper/css/bundle'
import 'animate.css'
import './styles/index.scss'

const root = document.getElementById('root')
if (!root) throw new Error('#root missing from index.html')

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
